"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Ticks;
exports.ScaleTicks = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _d3Selection = require("d3-selection");

var _d3Axis = require("d3-axis");

var _d3Format = require("d3-format");

var _Scale = require("./Scale");

var _clsx = _interopRequireDefault(require("clsx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Presentation component to render a d3 axis to display ticks.
 */
var ScaleTicks = function ScaleTicks(_ref) {
  var scale = _ref.scale,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? "bottom" : _ref$position,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 200 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 24 : _ref$height,
      ticks = _ref.ticks,
      tickArguments = _ref.tickArguments,
      tickFormat = _ref.tickFormat,
      tickValues = _ref.tickValues,
      tickSize = _ref.tickSize,
      tickSizeInner = _ref.tickSizeInner,
      tickSizeOuter = _ref.tickSizeOuter,
      tickPadding = _ref.tickPadding,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? {
    left: 0,
    right: 0
  } : _ref$margin,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["scale", "position", "width", "height", "ticks", "tickArguments", "tickFormat", "tickValues", "tickSize", "tickSizeInner", "tickSizeOuter", "tickPadding", "margin", "className"]);

  // adjust the scale for the inner width
  var innerWidth = width - (margin.left + margin.right);
  var scaleRange = [1, innerWidth - 1];
  var innerScale = scale.copy().range(scaleRange); // copy to avoid mutating the original scale
  // supports top or bottom aligned ticks

  var axisCreator = position === "bottom" ? (0, _d3Axis.axisBottom)(innerScale) : (0, _d3Axis.axisTop)(innerScale); // set the d3-axis properties

  if (tickFormat) {
    var formatFunc = typeof tickFormat === "string" ? (0, _d3Format.format)(tickFormat) : tickFormat;
    axisCreator = axisCreator.tickFormat(formatFunc);
  }

  if (ticks) axisCreator = axisCreator.ticks(ticks);
  if (tickArguments) axisCreator = axisCreator.tickArguments(tickArguments);
  if (tickValues) axisCreator = axisCreator.tickValues(tickValues);
  if (tickSize) axisCreator.tickSize(tickSize);
  if (tickSizeInner) axisCreator.tickSizeInner(tickSizeInner);
  if (tickSizeOuter) axisCreator.tickSizeOuter(tickSizeOuter);
  if (tickPadding) axisCreator.tickPadding(tickPadding); // calls the axis renderer when the dom reference is provided

  var axisRef = function axisRef(axis) {
    axis && axisCreator((0, _d3Selection.select)(axis));
  };

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    className: (0, _clsx["default"])("HypScale-ticks", className),
    width: width,
    viewBox: [0, 0, width, height]
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(".concat(margin.left, " 0)"),
    ref: axisRef
  }));
};

exports.ScaleTicks = ScaleTicks;
ScaleTicks.propTypes = {
  scale: _propTypes["default"].any,
  position: _propTypes["default"].oneOf(["bottom", "top"]),
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  ticks: _propTypes["default"].number,
  tickArguments: _propTypes["default"].array,
  tickFormat: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  tickValues: _propTypes["default"].array,
  tickSize: _propTypes["default"].number,
  tickSizeInner: _propTypes["default"].number,
  tickSizeOuter: _propTypes["default"].number,
  tickPadding: _propTypes["default"].number,
  margin: _propTypes["default"].object,
  className: _propTypes["default"].string
};
/** Tick component connected to the scale context */

function Ticks(props) {
  var _useScaleContext = (0, _Scale.useScaleContext)(),
      width = _useScaleContext.width,
      scale = _useScaleContext.position,
      margin = _useScaleContext.margin,
      type = _useScaleContext.type,
      chunks = _useScaleContext.chunks,
      thresholds = _useScaleContext.thresholds;

  var tickValues; // quantile and quantize have fixes tick values

  if (type === "quantile" || type === "quantize") tickValues = [].concat(_toConsumableArray(chunks.map(function (c) {
    return scale.invert(c.x);
  })), [scale.domain()[1]]); // threshold has fixed tick values at provided thresholds

  if (type === "threshold") tickValues = [scale.domain()[0]].concat(_toConsumableArray(thresholds), [scale.domain()[1]]);
  return /*#__PURE__*/_react["default"].createElement(ScaleTicks, _extends({
    width: width,
    scale: scale,
    margin: margin,
    tickValues: tickValues
  }, props));
}

Ticks.propTypes = ScaleTicks.propTypes;
ScaleTicks.__docgenInfo = {
  "description": "Presentation component to render a d3 axis to display ticks.",
  "methods": [],
  "displayName": "ScaleTicks",
  "props": {
    "position": {
      "defaultValue": {
        "value": "\"bottom\"",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "\"bottom\"",
          "computed": false
        }, {
          "value": "\"top\"",
          "computed": false
        }]
      },
      "required": false,
      "description": ""
    },
    "width": {
      "defaultValue": {
        "value": "200",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "height": {
      "defaultValue": {
        "value": "24",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "margin": {
      "defaultValue": {
        "value": "{ left: 0, right: 0 }",
        "computed": false
      },
      "type": {
        "name": "object"
      },
      "required": false,
      "description": ""
    },
    "scale": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": ""
    },
    "ticks": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "tickArguments": {
      "type": {
        "name": "array"
      },
      "required": false,
      "description": ""
    },
    "tickFormat": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "func"
        }]
      },
      "required": false,
      "description": ""
    },
    "tickValues": {
      "type": {
        "name": "array"
      },
      "required": false,
      "description": ""
    },
    "tickSize": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "tickSizeInner": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "tickSizeOuter": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "tickPadding": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};
Ticks.__docgenInfo = {
  "description": "Tick component connected to the scale context",
  "methods": [],
  "displayName": "Ticks"
};